<template>
  <b-modal
    v-model="visible"
    title="Kategoriyalarni boshqarish"
    hide-footer
    centered
    size="md"
    modal-class="z-top-modal"
  >
    <div class="s-container">
      <div class="s-input-area">
        <input
          ref="catInput"
          type="text"
          v-model="newCategoryName"
          placeholder="Yangi kategoriya nomi..."
          class="s-input"
          @keyup.enter="createCategory"
        >
        <button class="s-add-btn" :disabled="!newCategoryName" @click="createCategory">
          + Qo'shish
        </button>
      </div>

      <div class="s-list-card">
        <h4 class="s-list-title">Mavjud kategoriyalar ({{ localCategories.length }})</h4>
        <div class="s-scroll">
          <div v-for="cat in localCategories" :key="cat.id" class="s-item">
            <span class="s-name">{{ cat.name }}</span>
            <button class="s-del" @click="deleteCategory(cat.id)" title="O'chirish">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
            </button>
          </div>
          <div v-if="localCategories.length === 0" class="s-empty">
            Hozircha kategoriyalar yo'q
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios';

export default {
  name: 'XarajatSetting',
  props: {
    value: { type: Boolean, default: false },
    categories: { type: Array, default: () => [] },
  },
  data() {
    return {
      newCategoryName: '',
      localCategories: [],
    };
  },
  computed: {
    visible: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); }
    }
  },
  watch: {
    categories: {
      immediate: true,
      handler(v) { this.localCategories = [...(v || [])]; }
    },
    value(v) {
      if (v) this.$nextTick(() => setTimeout(() => this.$refs.catInput && this.$refs.catInput.focus(), 200));
    }
  },
  methods: {
    async createCategory() {
      if (!this.newCategoryName.trim()) return;
      try {
        const res = await axios.post('/api/v1/kassa-category', { name: this.newCategoryName.trim() });
        const newCat = res.data.data || res.data;
        this.localCategories.push(newCat);
        this.newCategoryName = '';
        this.$emit('changed');
      } catch (e) {
        alert("Kategoriya yaratishda xato: " + (e.response?.data?.message || e.message));
      }
    },
    async deleteCategory(id) {
      if (!confirm("Kategoriyani o'chirasizmi?")) return;
      try {
        await axios.delete(`/api/v1/kassa-category/${id}`);
        this.localCategories = this.localCategories.filter(c => c.id !== id);
        this.$emit('changed');
      } catch (e) {
        alert("O'chirish mumkin emas (ehtimol ishlatilgandir)");
      }
    }
  }
};
</script>

<style scoped>
.s-container { display: flex; flex-direction: column; gap: 14px; }
.s-input-area { display: flex; gap: 8px; }
.s-input {
  flex: 1;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  outline: none;
  font-size: 14px;
}
.s-input:focus { border-color: #be185d; box-shadow: 0 0 0 3px rgba(190,24,93,.1); }
.s-add-btn {
  background: linear-gradient(135deg, #be185d, #db2777);
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}
.s-add-btn:disabled { opacity: .5; cursor: not-allowed; }
.s-list-card { background: #f8fafc; border-radius: 12px; padding: 14px; }
.s-list-title { font-size: 13px; color: #64748b; margin: 0 0 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .5px; }
.s-scroll { max-height: 280px; overflow-y: auto; display: flex; flex-direction: column; gap: 6px; }
.s-item { display: flex; justify-content: space-between; align-items: center; padding: 8px 12px; background: white; border-radius: 8px; border: 1px solid #f1f5f9; }
.s-name { font-weight: 600; color: #334155; }
.s-del { background: #fff1f2; color: #e11d48; border: none; width: 28px; height: 28px; border-radius: 8px; display: flex; align-items: center; justify-content: center; cursor: pointer; }
.s-del:hover { background: #e11d48; color: white; }
.s-empty { text-align: center; color: #94a3b8; padding: 30px 0; font-style: italic; font-size: 13px; }
</style>
